import RecommendModal from './RecommendModal';

export default RecommendModal;
